// extracted by mini-css-extract-plugin
export default {"headerText":"Researchpaper_headerText__KTSh4","researchText":"Researchpaper_researchText__xOkRG","researchSubText":"Researchpaper_researchSubText__bweM8"};